import { DOMOutputSpec, DOMSerializer } from 'prosemirror-model'
import { EditorView } from 'prosemirror-view'

/**
 * The type for the toDOM function for widgets
 */
// prosemirror-view defines but doesn't export this type, and it's messy to pull
// this out of the actual `Decoration.widget` arguments
export interface WidgetConstructor {
  (view: EditorView, getPos: () => number | undefined): HTMLElement
}

/**
 * Curried helper for creating widget decorations from a `DOMOutputSpec`
 *
 * This lets you describe widget DOM declaratively using the same array syntax
 * used in node `toDOM` specs, rather than building elements using the vanilla
 * browser methods. Most importantly, contents are always rendered as text
 * nodes, never parsed as HTML, so it's good for user-generated strings
 *
 * @see https://prosemirror.net/docs/ref/#model.DOMOutputSpec
 * @see https://prosemirror.net/docs/ref/#view.Decoration^widget
 *
 * @example
 * Decoration.widget(pos, fromSpec(['span', { class: 'rating' }, '★★★★']))
 */

export function fromSpec(spec: DOMOutputSpec): WidgetConstructor {
  return (view) => {
    const { dom } = DOMSerializer.renderSpec(view.dom.ownerDocument, spec)
    return dom
  }
}
